export const SET_DARK_MODE = "SET_DARK_MODE";
export const SET_USER_LOGGED = "SET_USER_LOGGED";
export const SET_SIDE_MENU = "SET_SIDE_MENU";
export const SET_LOCAL = "SET_LOCAL";
export const SET_USER_DATA = "SET_USER_DATA";
export const SET_UUID = "SET_UUID";